module.exports = __webpack_public_path__ + "img/hero2.49fcdc12.jpg";